/* faith-header-cathedral.js — Cathedral header interactions.
   - Toggles .is-scrolled on the nav after a threshold of scroll
   - Opens/closes the mobile drawer + locks body scroll while open */

(function () {
  'use strict';

  // The Theme Editor re-renders the header section on every edit, replacing the
  // nav and drawer nodes. Anything bound to window/document is therefore bound
  // once and re-queries the live node; per-node handlers are re-bound on each
  // init (they arrive with the fresh markup).
  var globalsBound = false;

  function init() {
    var nav = document.querySelector('[data-faith-nav]');
    if (!nav) return;

    bindGlobals();
    syncScrollState();
    setupDrawer();
  }

  function syncScrollState() {
    var nav = document.querySelector('[data-faith-nav]');
    if (!nav) return;
    var threshold = parseInt(nav.dataset.scrollThreshold, 10) || 40;
    nav.classList.toggle('is-scrolled', window.scrollY > threshold);
  }

  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          syncScrollState();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      var drawer = document.querySelector('[data-faith-nav-drawer]');
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
        closeDrawer(drawer);
      }
    });
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('[data-faith-nav-toggle]').forEach(function (t) {
      if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false');
    });
  }

  function setupDrawer() {
    // The drawer + its close button now live OUTSIDE <header> (see
    // header-cathedral.liquid for why), and the hamburger toggle lives inside
    // it — so scope these lookups to the document, not the nav element.
    var drawer = document.querySelector('[data-faith-nav-drawer]');
    var toggles = document.querySelectorAll('[data-faith-nav-toggle]');
    if (!drawer || !toggles.length) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      toggles.forEach(function (t) {
        if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'true');
      });
    }
    function close() { closeDrawer(drawer); }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) close();
        else open();
      });
    });

    drawer.querySelectorAll('.faith-nav__drawer-link').forEach(function (link) {
      link.addEventListener('click', close);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-faith-nav]')) init();
  });
})();
